import { useMemo } from "react";
import { useTranslations } from "adapters/i18n";

export function useStateOptions() {
  const { t } = useTranslations();

  const options = useMemo(
    () => [
      { value: 0, label: t("common:all-male").toUpperCase() },
      { value: 1, label: t("common:status.activated-plural").toUpperCase() },
      { value: 2, label: t("common:status.disabled-plural").toUpperCase() },
    ],
    [t]
  );

  return options;
}
